import { Modal, Table } from "react-bootstrap";

const ShippingLinesModal = ({ showShippingModal, setShowShippingModal, selectedShippingLines }) => {
return (
<Modal 
show={showShippingModal} 
onHide={() => setShowShippingModal(false)} 
size="lg"
centered
>
<Modal.Header closeButton>
  <Modal.Title>Shipping Methods</Modal.Title>
</Modal.Header>
<Modal.Body>
  {selectedShippingLines && selectedShippingLines.length > 0 && (
    <div>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Method</th>
            <th>Title</th>
            <th>Cost</th>
            <th>Tax Status</th>
            <th>Metadata</th>
          </tr>
        </thead>
        <tbody>
          {selectedShippingLines.map((method, index) => (
            <tr key={index}>
              <td>{method.method_id}</td>
              <td>{method.method_title}</td>
              <td>{parseFloat(method.total).toFixed(2)}</td>
              <td>{method.tax_status}</td>
              <td>
                {method.meta_data && method.meta_data.length > 0 ? (
                  <Table size="sm" borderless>
                    <tbody>
                      {method.meta_data.map((meta, metaIndex) => (
                        <tr key={metaIndex}>
                          <td><strong>{meta.display_key || meta.key}:</strong></td>
                          <td>{meta.display_value || meta.value}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <span className="text-muted">No metadata</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  )}
</Modal.Body>
</Modal>
);  
}
export default ShippingLinesModal;
